// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { useContext } from "react";
import { OnboardingContext } from "../context/OnboardingContext";
import type { TeamSize, WorkRole } from "../features/onboarding/models/onboardingModels";

export interface WorkspaceFocus {
  workFocus: WorkRole | undefined;
  teamSizeBand: TeamSize | undefined;
  showsPropertySurfaces: boolean;
  showsSalesSurfaces: boolean;
  isSolo: boolean;
}

export function useWorkspaceFocus(): WorkspaceFocus {
  const profile = useContext(OnboardingContext)?.workspaceProfile;
  const workFocus = profile?.workFocus;
  const teamSizeBand = profile?.teamSizeBand;

  return {
    workFocus,
    teamSizeBand,
    showsPropertySurfaces: workFocus !== "sales",
    showsSalesSurfaces: workFocus !== "property",
    isSolo: teamSizeBand === "solo",
  };
}
